import { render, staticRenderFns } from "./pitcherStatistics.vue?vue&type=template&id=01f33f2e&scoped=true"
import script from "./pitcherStatistics.vue?vue&type=script&lang=js"
export * from "./pitcherStatistics.vue?vue&type=script&lang=js"
import style0 from "./pitcherStatistics.vue?vue&type=style&index=0&id=01f33f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f33f2e",
  null
  
)

export default component.exports